/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber15Small = createReactComponent("outline", "number-15-small", "IconNumber15Small", [["path", { "d": "M7 10l2 -2v8", "key": "svg-0" }], ["path", { "d": "M13 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-1" }]]);

export { IconNumber15Small as default };
//# sourceMappingURL=IconNumber15Small.mjs.map
